import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from '../ofbiz-form-model';

@Component({
  selector: 'ubs-ofbiz-cell-sequence',
  template: `<input nbInput type="number" fieldSize="tiny" [(ngModel)]="value">`,
  styleUrls: ['./ofbiz-cell-sequence.component.scss']
})
export class OfbizCellSequenceComponent implements ViewCell, OnInit {
  
  value: string | number;
  rowData: any;
  @Input() field:any;
  @Input() editable:boolean;
  
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

}
